import useShallowEqualSelector from 'hooks/useShallowEqualsSelector';
import { ReducerKeys } from 'redux/config';
import { StateStatus } from 'redux/utils/common';
import { IState } from './reducer';
import * as ProductService from 'services/api/product';

export const useGetCategory = (): IState['category'] => {
  const data = useShallowEqualSelector(
    (state: any) =>
      (state[ReducerKeys.PRODUCT_FILTER_REDUCER] as IState).category
  );
  return data;
};

export const useGetFilterSelections = (): IState['filtersSelection'] => {
  const data = useShallowEqualSelector(
    (state: any) =>
      (state[ReducerKeys.PRODUCT_FILTER_REDUCER] as IState).filtersSelection
  );
  return data;
};

export const useGetAgents = (): IState['agents']['data'] => {
  const data = useShallowEqualSelector(
    (state: any) =>
      (state[ReducerKeys.PRODUCT_FILTER_REDUCER] as IState).agents.data
  );
  return data;
};

export const useGetCustomFilteredSpecs =
  (): IState['customAttributes']['data'] => {
    const data = useShallowEqualSelector(
      (state: any) =>
        (state[ReducerKeys.PRODUCT_FILTER_REDUCER] as IState).customAttributes
          .data
    );
    return data;
  };

export const useGetCity = (): IState['city']['data'] => {
  const city = useShallowEqualSelector(
    (state: any) =>
      (state[ReducerKeys.PRODUCT_FILTER_REDUCER] as IState).city.data
  );
  return city;
};

export const useGetMunicipality = (): IState['municipality']['data'] => {
  const municipality = useShallowEqualSelector(
    (state: any) =>
      (state[ReducerKeys.PRODUCT_FILTER_REDUCER] as IState).municipality.data
  );
  return municipality;
};

export const useGetProductStatuses = (): {
  property_status: ProductService.ISpec;
  availability_status: ProductService.ISpec;
} => {
  const property_status = useShallowEqualSelector(
    (state: any) =>
      (state[ReducerKeys.PRODUCT_FILTER_REDUCER] as IState).segments.data
        ?.property_status
  );

  const availability_status = useShallowEqualSelector(
    (state: any) =>
      (state[ReducerKeys.PRODUCT_FILTER_REDUCER] as IState).segments.data
        ?.availability_status
  );
  return { property_status, availability_status };
};

export const useGetSegments = (): IState['segments'] => {
  const data = useShallowEqualSelector(
    (state: any) =>
      (state[ReducerKeys.PRODUCT_FILTER_REDUCER] as IState).segments
  );

  return data;
};

export const useGetClientCustomers = (): Array<ProductService.IMiniProfile> => {
  const customers = useShallowEqualSelector(
    (state: any) =>
      (state[ReducerKeys.PRODUCT_FILTER_REDUCER] as IState).clientCustomers.data
  );
  return customers;
};

export const useGetZonesList = (): IState['zoneList'] => {
  const data = useShallowEqualSelector(
    (state: any) => state[ReducerKeys.PRODUCT_FILTER_REDUCER].zoneList
  );
  return data;
};
